'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.filter('obfuscateIrn', function() {
  return function(text) {
    var regex = /^\d{6}/;
    return String(text).replace(regex, '******');
  };
});
